module.exports = __webpack_public_path__ + "static/media/logo.91caa1f7.png";